<template>
    <a-modal title="工单详情" width="60%" :open="true" :confirmLoading="state.loading" @cancel="
        () => {
            emit('cancel')
        }
    " :footer="false">
        <a-spin :spinning="allstate.zhuti_effect_loading" tip="正在更新平台方对该工单态度，请稍后...">
            <a-watermark :content="state.allperson" :gap="[200, 200]" fontWeight="light">
                <a-skeleton :loading="state.loading" active :paragraph="{ rows: 4 }">
                    <div class="p-1x">
                        <a-descriptions size="small" :column="2" :bordered="true">
                            <a-descriptions-item label="工单标题">
                                <div>{{ props.tableColumnsData.title }}&nbsp;</div>
                            </a-descriptions-item>
                            <a-descriptions-item label="关联主体：">
                                <div v-if="props.tableColumnsData.full_name"
                                    @click="goCustomerClick(props.tableColumnsData.full_name)" class="pointer">
                                    {{ props.tableColumnsData.full_name }}
                                </div>
                                <MoreInfo :customerData="{ id: props.tableColumnsData.customer_id }"></MoreInfo>
                                <a-divider type="vertical"></a-divider>
                                <a @click="showLog()">日志</a>
                                <a-divider type="vertical"></a-divider>
                                <a-tag v-if="!props.tableColumnsData.full_name" color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.custodian_admin_info">
                                    {{ item.nickname }} {{ item.phone }}
                                </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="类型/状态">
                                <a-tag color="red" v-if="props.tableColumnsData.type == 1">投诉</a-tag>
                                <a-tag color="orange" v-else-if="props.tableColumnsData.type == 2">举报</a-tag>
                                <a-tag color="blue" v-else-if="props.tableColumnsData.type == 4">信函</a-tag>
                                <a-tag color="blue" v-else-if="props.tableColumnsData.type == 3">代办事项</a-tag>
                                <a-tag color="green" v-else>其他事项</a-tag>/
                                <a-tag color="green">{{
                                    props.tableColumnsData.status == 0
                                        ? '待处理'
                                        : props.tableColumnsData.status == 4
                                            ? '处理中'
                                            : props.tableColumnsData.status == 1
                                                ? '已办结'
                                                : props.tableColumnsData.status == 2
                                                    ? '已取消'
                                                    : '已删除'
                                }}</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="工单截止时间">
                                {{ props.tableColumnsData.start_time }} ~
                                {{ props.tableColumnsData.end_time }}
                            </a-descriptions-item>

                            <a-descriptions-item label="代理姓名">
                                <a-tag color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.reception_admin_info"> {{
                                        item.nickname }} {{ item.phone }} </a-tag>
                            </a-descriptions-item>

                            <a-descriptions-item label="执行负责人">
                                <a-tag color="green" class="mr-1x mb-1x"
                                    v-for="(item, index) in props.tableColumnsData.custodian_admin_info"> {{
                                        item.nickname }} {{ item.phone }} </a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="涉及金额"
                                v-if="props.tableColumnsData.type == 1 || props.tableColumnsData.type == 2">
                                {{ props.tableColumnsData.tousu_money ? props.tableColumnsData.tousu_money + '元' : '无'
                                }}
                            </a-descriptions-item>
                            <a-descriptions-item label="投诉人姓名及电话"
                                v-if="props.tableColumnsData.type == 1 || props.tableColumnsData.type == 2">
                                <a-tooltip title="小技巧：给投诉举报人打电话的时候，一定要问：商家给您处理好了吗？ 并录音，得到其回复“处理好了”，则本工单办结。">
                                    {{ props.tableColumnsData.tousu_name }} {{ props.tableColumnsData.tousu_tel }}
                                    <a v-if="props.tableColumnsData.tousu_tel"
                                        @click="onUsbphoneClick(props.tableColumnsData, props.tableColumnsData.tousu_tel)">
                                        <PhoneOutlined />
                                    </a>
                                </a-tooltip>
                            </a-descriptions-item>
                            <a-descriptions-item label="工单内容" :span="2" style="width: 105px">
                                <div>{{ props.tableColumnsData.content }}</div> <a
                                    v-if="props.tableColumnsData.wo_type == 13"
                                    @click="exportTaskBill(props.tableColumnsData)">下载账单
                                    <LoadingOutlined v-if="state.exportLoading" />
                                </a>
                                <a-button type="primary" size="small" v-else-if="props.tableColumnsData.wo_type == 14"
                                    @click="openPayCenter">支付差额</a-button>
                            </a-descriptions-item>

                            <a-descriptions-item label="工单附件" :span="2">
                                <span v-for="(item, index) in props.tableColumnsData.attachment">
                                    <a-image
                                        v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                                        :key="index" :width="100" :height="100"
                                        :src="$store.state.user.image_domain + item.url">
                                    </a-image>
                                    <a v-else :href="$store.state.user.image_domain_a + item.url" download
                                        target="_blank">{{ item.name }}</a>
                                </span>
                            </a-descriptions-item>

                            <!-- ===================== 最新动态：仿微信聊天区 ===================== -->
                            <a-descriptions-item label="最新动态" :span="2">
                                <div class="chat-wrap">
                                    <div class="chat-list" ref="chatListRef">
                                        <template v-if="state.work_order_chat?.length">
                                            <div v-for="(item, index) in state.work_order_chat" :key="index"
                                                class="chat-item" :class="{ 'chat-item--self': item.is_self == 1 }">
                                                <a-avatar class="chat-avatar" :size="36">
                                                    {{ (item.send_info?.nickname || '?').slice(0, 1) }}
                                                </a-avatar>
                                                <div class="chat-body">
                                                    <div class="chat-meta">
                                                        <span class="chat-name">{{ item.send_info?.nickname }}</span>
                                                        <span class="chat-time">{{ item.created_at }}</span>
                                                        <a-badge v-if="item.is_read == 0" dot />
                                                    </div>
                                                    <div class="chat-bubble">
                                                        <p class="chat-status">{{ item.after_status_name }}</p>
                                                        <p v-html="item.msg"></p>
                                                        <div v-if="item.attachment" class="chat-attach">
                                                            <span v-for="(att, i) in item.attachment" :key="i">
                                                                <a-image
                                                                    v-if="att.name.indexOf('jpg') > -1 || att.name.indexOf('png') > -1 || att.name.indexOf('jpeg') > -1"
                                                                    :width="120"
                                                                    :src="$store.state.user.image_domain + att.url" />
                                                                <a v-else
                                                                    :href="$store.state.user.image_domain + att.url"
                                                                    target="_blank">{{ att.name }}</a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <a-empty v-else description="暂无沟通记录" class="flex-center flex-dc" />
                                    </div>

                                    <!-- 底部输入区：独立卡片，边框包裹 -->
                                    <div class="chat-editor">
                                        <div class="chat-editor__toolbar">
                                            <Upload
                                                :upload_path="`public/uploads/manage/工单/${dayjs().format('YYYYMM')}/`"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'm4a', 'mp3', 'amr', 'aac', 'wav', 'awb', '3ga', '3gp', 'wac'

                                                ]" v-model:value="state.attachment" uploadType="text" :limitation="9"
                                                uploadText="上传附件">
                                            </Upload>
                                        </div>
                                        <a-textarea v-model:value="state.content" class="chat-editor__input"
                                            placeholder="请输入发布内容，Enter 发送，Shift+Enter 换行"
                                            :auto-size="{ minRows: 2, maxRows: 6 }" @pressEnter="onEditorEnter" />
                                        <div class="chat-editor__footer">
                                            <span class="chat-editor__tip">已选 {{ state.attachment?.length || 0 }}
                                                个附件</span>
                                            <a-button type="primary" :loading="state.fbloading"
                                                @click="submit"><template #icon>
                                                    <SendOutlined />
                                                </template>发送</a-button>
                                        </div>
                                    </div>
                                </div>
                            </a-descriptions-item>

                            <a-descriptions-item label="短信回复案例" :span="2">
                                <p>市民您好，关于您在12345平台上投诉的xx一事，经查，商家不在注册地址经营，我局无法与其取得联系。依据《市场监督管理投诉举报处理办法》第十八条:"市场监督管理部门经投诉人和被投诉人同意，采用调解的方式处理投诉，但法律、法规另有规定的，依照其规定”的规定，采用调解方式处理投诉的前提是需要投诉人和被投诉人双方同意，但因被投诉人经我局工作人员核实下落不明，无法联系，无法取得其同意，所以我局无法采用调解方式进行处理。建议您走司法途径维权。XXX市场监督管理所，咨询电话:XXX-XXXXXXXX
                                </p>
                                <p>市民您好，关于您在12345平台上投诉的，XXX一事，经协调，商家表示无法满足投诉人诉求，依据《市场监督管理投诉举报处理办法》第二十三条第一款有下列情形之一，终止调解“(三)经组织调解，投诉人或者被投诉人明确表示无法达成调解协议的"之规定，我局现终止调解。建议您走司法途径维权。XXXX市场监督管理所，咨询电话:XXXX-XXXXXXX
                                </p>
                                <P></P>
                            </a-descriptions-item>
                        </a-descriptions>

                        <!-- ===================== 工单操作区（独立） ===================== -->
                        <div class="order-actions">
                            <a-divider style="border-color: #f0f0f0; margin: 20px 0">工单操作</a-divider>

                            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                <a-form-item label="主体影响" required>
                                    <a-radio-group v-model:value="props.tableColumnsData.zhuti_effect"
                                        button-style="solid" @change="change_zhuti_effect">
                                        <a-radio-button :value="1">消极影响</a-radio-button>
                                        <a-radio-button :value="2">不影响</a-radio-button>
                                    </a-radio-group>
                                </a-form-item>

                                <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
                                    <a-popconfirm title="确定办结此工单?" @confirm="changeStatus(1)">
                                        <a-button class="mr-1x" type="primary"
                                            :disabled="props.tableColumnsData.zhuti_effect == 0"
                                            :loading="state.statusLoading === 1">
                                            办结工单
                                        </a-button>
                                    </a-popconfirm>

                                    <a-popconfirm title="确定取消此工单?" @confirm="changeStatus(2)">
                                        <a-button class="mr-1x" danger :loading="state.statusLoading === 2">
                                            取消工单
                                        </a-button>
                                    </a-popconfirm>

                                    <a-popconfirm title="确定转为恢复待处理?" @confirm="changeStatus(0)">
                                        <a-button class="mr-1x" :loading="state.statusLoading === 0">恢复待处理</a-button>
                                    </a-popconfirm>

                                    <a-popconfirm title="确定为转为久悬工单吗?" @confirm="changeStatus(5)">
                                        <a-button class="mr-1x"
                                            style="background: #000; border-color: #000; color: #fff"
                                            :disabled="props.tableColumnsData.zhuti_effect == 0"
                                            :loading="state.statusLoading === 5">
                                            转为久悬工单
                                        </a-button>
                                    </a-popconfirm>

                                    <span v-if="props.tableColumnsData.zhuti_effect == 0" class="ml-1x"
                                        style="color: #ff4d4f">
                                        请先选择"主体影响"再办结/久悬
                                    </span>
                                </a-form-item>
                            </a-form>
                        </div>

                        <!-- ===================== 核实功能区（已办结/久悬） ===================== -->
                        <div v-if="props.tableColumnsData.status == 1 || props.tableColumnsData.status == 5">
                            <a-divider style="border-color: #f0f0f0; margin: 20px 0">以下是平台管理员核实专属功能区</a-divider>
                            <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                <a-form-item label="核实备注">
                                    <a-textarea v-model:value="state.verifyRemark" placeholder="请输入核实备注"
                                        :auto-size="{ minRows: 2, maxRows: 10 }" />
                                </a-form-item>
                                <a-form-item :wrapper-col="{ span: 20, offset: 4 }"
                                    v-if="state.user_permission == 'admin' || state.user_permission == 'platform'">
                                    <a-popconfirm title="确定核实通过此工单吗?" @confirm="() => handleVerify('pass')">
                                        <a-button class="mr-1x" type="primary"
                                            :loading="state.verifyLoading === 'pass'">核实通过</a-button>
                                    </a-popconfirm>

                                    <a-popconfirm title="确定重新处理此工单吗?" @confirm="() => handleVerify('reprocess')">
                                        <a-button class="mr-1x" type="primary"
                                            :loading="state.verifyLoading === 'reprocess'">重新处理</a-button>
                                    </a-popconfirm>
                                </a-form-item>
                            </a-form>
                        </div>

                        <transfer-order v-if="state.transferOrderVisible" ref="transferOrderRef" @cancel="
                            () => {
                                state.transferOrderVisible = false
                            }
                        "></transfer-order>
                    </div>
                </a-skeleton>
            </a-watermark>
        </a-spin>
        <PayCenter :tableColumnsData="state.custData" v-if="state.addressRenewVisible" @cancel="handleCancel"
            @ok="handleOk" ref="payCenterRef">
        </PayCenter>
        <!-- 查看日志 -->
        <view-log :logTabsKey="1" v-if="state.visibleLog" :tableColumnsData="state.custData"
            @cancel="handleCancel"></view-log>
    </a-modal>
</template>

<script lang="ts" setup>
import cloneDeep from 'lodash.clonedeep'
import { LoadingOutlined, PhoneOutlined, SendOutlined } from '@ant-design/icons-vue'
import transferOrder from './transferOrder.vue'
import { ref, reactive, onMounted, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import Upload from '@/components/base/Upload.vue'
import PayCenter from '../../customer/components/PayCenter.vue'
import ViewLog from '../../customer/components/ViewLog.vue'
const $store = useStore()
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import MoreInfo from '../../customer/components/MoreInfo.vue'
const router = useRouter()
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => null
    }
})

onMounted(() => {
    queryDetail()
})
const formRef = ref()
const emit = defineEmits(['cancel', 'ok'])
const chatListRef = ref<HTMLElement | null>(null)
const state = reactive<any>({
    transferOrderVisible: false,
    loading: false,
    fbloading: false,
    content: null,
    attachment: [],
    // 上传文件
    fileList: [],
    detailData: {},
    fileInformation: [],
    work_order_chat: [],
    allperson: '',
    exportLoading: false,
    verifyRemark: '', // 核实备注
    statusLoading: null, // 状态按钮loading: 0,1,2,5
    verifyLoading: null, // 核实按钮loading: 'pass', 'reprocess'
    user_permission: 'seller',
    addressRenewVisible: false,
    custData: {},
    visibleLog: false,
})
const goCustomerClick = (name) => {
    emit('cancel')
    router.push({ path: '/customer', query: { customer_name: name, tabsKey: 2 } })
}
const allstate = reactive<any>({
    zhuti_effect_loading: false
})
const change_zhuti_effect = () => {
    allstate.zhuti_effect_loading = true
    let requestParam = {
        url: '/admin/v1/workOrder/changeZhutiEffect',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            zhuti_effect: props.tableColumnsData.zhuti_effect
        }
    }
    baseService(requestParam)
        .then((res) => {
            allstate.zhuti_effect_loading = false
            message.success(res.msg ? res.msg : '操作成功')
        })
        .catch((res) => {
            allstate.zhuti_effect_loading = false
        })
}
const queryDetail = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/workOrderChatLog?id=` + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            state.work_order_chat = res.data.work_order_chat
            state.user_permission = res.data.user_permission
            state.allperson = allperson(props.tableColumnsData.reception_admin_info)
            nextTick(() => {
                scrollChatToBottom()
            })
        })
        .catch((res) => {
            state.loading = false
        })
}
const allperson = (p) => {
    let text = ''
    for (let itemindex in p) {
        text += p[itemindex].nickname + '&&'
    }
    return text.substring(0, text.length - 2)
}
const onTransferOrderOk = () => {
    state.transferOrderVisible = false
    emit('ok')
}

const changeStatus = (type) => {
    if ([1, 5].includes(type) && props.tableColumnsData.zhuti_effect == 0) {
        message.error('请选择"主体影响"后再办结此工单！')
        return false
    }
    state.statusLoading = type
    let requestParam = {
        url: '/admin/v1/workOrder/changeStatus',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            status: type
        }
    }
    baseService(requestParam)
        .then((res) => {
            message.success(res.msg ? res.msg : '操作成功')
            state.statusLoading = null
            emit('ok')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '操作失败')
            state.statusLoading = null
        })
}

// Enter 发送，Shift+Enter 换行
const onEditorEnter = (e: KeyboardEvent) => {
    if (e.shiftKey) return
    e.preventDefault()
    if (state.fbloading) return
    submit()
}

const scrollChatToBottom = () => {
    if (chatListRef.value) {
        chatListRef.value.scrollTop = chatListRef.value.scrollHeight
    }
}

const submit = () => {
    if (!state.content && (!state.attachment || state.attachment.length === 0)) {
        message.error('回复内容或附件不能为空')
        return
    }
    state.fbloading = true
    let requestParam = {
        url: '/admin/v1/workOrder/reply',
        method: 'post',
        data: {
            work_order_id: props.tableColumnsData.id,
            msg: state.content,
            attachment: state.attachment
        }
    }
    baseService(requestParam)
        .then((res) => {
            message.success(res.msg ? res.msg : '操作成功')
            state.content = null
            state.attachment = []
            queryDetail()
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '操作失败')
        })
        .finally(() => {
            state.fbloading = false
        })
}
const onTransferOrderClick = () => {
    state.transferOrderVisible = true
}
// 计划任务-下载账单
const exportTaskBill = (record) => {
    let snarr = record.sn.split("#");
    let type = snarr[0]
    if (type == 'gengcaiFreeZhang') {
        //耿才免费送章
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            action: ['kezhang'],
            coupon_id: 21
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'wawajiaoServiceFee') {
        //哇哇叫服务费
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            action: ['kezhang']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'kaifu2302ServiceFee') {
        //开福区2302的服务商共计
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [15],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'wajieServiceFee') {
        //万捷孵化器佣金：万捷、万捷分公司、万多、万永、多尚
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [1, 2, 3, 9, 11],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'duoyouServiceFee') {
        //多友，洞井
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [14],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else if (type == 'gengcaiServiceFee') {
        //耿才
        let month = snarr[1]
        let queryParam = {
            between_time: monthToBetween_time(month),
            platform_id: [36],
            action: ['custRegister', 'custRenewal', 'custOther']
        }
        state.exportLoading = true
        let requestParam = {
            url: '/admin/v1/orders/export',
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                responseType: 'blob'
            },
            data: Object.assign({ type: 2, limit: 'all', page: 1, version: 'admin', hideSeller: 1 }, queryParam)
        }
        baseService(requestParam)
            .then((res) => {
                message.success('下载成功')
            })
            .catch((res) => {
                state.exportLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('下载失败')
                }
            }).finally(() => {
                state.exportLoading = false
            })
    } else {
        message.error('暂不支持下载')
    }
}
//辅助函数将202601 转换
const monthToBetween_time = (month) => {
    // 解析年月
    const year = month.slice(0, 4);
    const monthStr = month.slice(4); // "01"

    // 直接拼接开始时间
    const startStr = `${year}-${monthStr}-01 00:00:00`;

    // 计算结束时间
    const lastDay = new Date(year, parseInt(monthStr), 0).getDate();
    const endStr = `${year}-${monthStr}-${lastDay.toString().padStart(2, '0')} 23:59:59`;
    return [startStr, endStr];
}
const onUsbphoneClick = (record, phone) => {
    console.log(record)
    $store.dispatch('usbphone/AddPhoneModal', {
        phone: phone,
        customer_id: record.customer_id,
        full_name: record.title
    })
}
const handleVerify = (type: string): void => {
    state.verifyLoading = type
    let requestParam = {
        url: '/admin/v1/workOrder/verify',
        method: 'post',
        data: {
            id: props.tableColumnsData.id,
            type: type,
            verify_remark: state.verifyRemark
        }
    }

    baseService(requestParam)
        .then((res) => {
            let tipMsg = type === 'pass' ? '核实通过成功' : '重新处理成功'
            message.success(res.data?.msg ? res.data.msg : tipMsg)
            state.verifyRemark = ''
            state.verifyLoading = null
            emit('ok')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '操作失败')
            state.verifyLoading = null
        })
}
const payCenterRef = ref(null)
const openPayCenter = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 1 }, { address_number: props.tableColumnsData.full_address, nameOrCode: props.tableColumnsData.full_name })
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data.list.length > 0) {
                state.custData = res.data.list[0]
                state.addressRenewVisible = true
                nextTick(() => {
                    payCenterRef.value?.initPage('小规模转一般纳税人')
                })
            } else {
                message.error('未查询到客户信息')
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
const handleCancel = () => {
    state.addressRenewVisible = false
    state.visibleLog = false
}
const handleOk = () => {
    state.addressRenewVisible = true
}
const showLog = () => {
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 1, breakAdmin: 1 }, { customer_id: props.tableColumnsData.customer_id })
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data.list.length > 0) {
                state.custData = res.data.list[0]
                state.visibleLog = true
            } else {
                message.error('未查询到客户信息')
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })


}
</script>

<style lang="less" scoped>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 65px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin-bottom: 10px;
}

.timelineStatus {
    .ant-timeline-item:first-child {
        color: #ff5000;

        p:first-child {
            color: #ff5000;
        }
    }
}

/* ===================== 仿微信聊天区 ===================== */
.chat-wrap {
    display: flex;
    flex-direction: column;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
    background: #f7f7f7;
    width: 100%;
}

.chat-list {
    max-height: 360px;
    overflow-y: auto;
    padding: 16px 12px 8px;
}

.chat-item {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
}

.chat-item--self {
    flex-direction: row-reverse;
}

.chat-item--self .chat-bubble {
    background: #95ec69;
}

.chat-item--self .chat-meta {
    flex-direction: row-reverse;
}

.chat-avatar {
    flex-shrink: 0;
    background: #1890ff;
}

.chat-body {
    max-width: 70%;
}

.chat-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
}

.chat-name {
    color: #333;
    font-weight: 500;
}

.chat-bubble {
    background: #fff;
    border-radius: 8px;
    padding: 8px 12px;
    word-break: break-all;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.chat-bubble .chat-status {
    font-size: 12px;
    color: #ff5000;
    margin-bottom: 4px;
}

.chat-attach {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

/* 输入区：独立卡片，边框包裹 + 聚焦高亮 */
.chat-editor {
    margin: 8px 12px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    background: #fff;
    padding: 8px 12px 10px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus-within {
        border-color: #1677ff;
        box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
    }
}

.chat-editor__toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px dashed #f0f0f0;
}

.chat-editor__input {
    border: none !important;
    box-shadow: none !important;
    resize: none;
    padding: 4px 0;
}

.chat-editor__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    padding-top: 8px;
    border-top: 1px dashed #f0f0f0;
}

.chat-editor__tip {
    font-size: 12px;
    color: #999;
}

.order-actions {
    margin-top: 8px;
}
</style>
